import "./MobileSiteApp.css";
import { useState } from "react";
import { useLang } from "../../../i18n/LangContext";

export default function MobileSiteApp() {
  const { t } = useLang();
  const [showNotice, setShowNotice] = useState(false);
  const home = t?.home || {};
  const services = t?.services || {};

  const handleDesktopOnly = (e) => {
    e.preventDefault();
    setShowNotice(true);
  };

  return (
    <div className="mobile-site">
      <header className="mobile-site__nav">
        <div className="mobile-site__brand">Givvy</div>
        <button className="mobile-site__cta" onClick={handleDesktopOnly}>Get Started</button>
      </header>

      <section className="mobile-site__hero">
        <p className="mobile-site__eyebrow">{home.eyebrow || "WELCOME"}</p>
        <h1 className="mobile-site__title">
          {Array.isArray(home.title) ? home.title.join(" ") : home.title || "Global App & Content Connections"}
        </h1>
        <p className="mobile-site__desc">{home.desc || "Monetize smarter with premium offerwall tools."}</p>
        <div className="mobile-site__hero-actions">
          <button className="mobile-site__btn" onClick={handleDesktopOnly}>Get Started</button>
          <a className="mobile-site__btn ghost" href="/contact">Contact</a>
        </div>
      </section>

      <section className="mobile-site__card">
        <h2>{services.eyebrow || "OUR SERVICES"}</h2>
        <div className="mobile-site__service">
          <h3>Advertise</h3>
          <p>{services?.advertise?.desc || "Reach engaged audiences with premium placements."}</p>
        </div>
        <div className="mobile-site__service">
          <h3>Monetize</h3>
          <p>{services?.monetize?.desc || "Boost revenue with lightweight offerwall SDK."}</p>
        </div>
      </section>

      <section className="mobile-site__stats">
        <div>
          <span>{t?.stats?.publishers || "Publishers"}</span>
          <strong>{t?.stats?.payout || "$1M+"}</strong>
        </div>
        <div>
          <span>{t?.stats?.mauLabel || "Monthly Active Users"}</span>
          <strong>{t?.stats?.mau || "20M+"}</strong>
        </div>
        <div>
          <span>{t?.stats?.advertisers || "Advertisers"}</span>
          <strong>{t?.stats?.adv || "150K+"}</strong>
        </div>
      </section>

      <section className="mobile-site__cta-block">
        <h2>Ready to grow?</h2>
        <p>Join publishers and advertisers building revenue with Givvy.</p>
        <button className="mobile-site__btn" onClick={handleDesktopOnly}>Start Now</button>
      </section>

      <footer className="mobile-site__footer">
        <div>© 2024 Givvy</div>
        <div className="mobile-site__footer-links">
          <a href="/faq">FAQ</a>
          <a href="/contact">Contact</a>
          <a href="/offerwall">Offerwall</a>
        </div>
      </footer>
    
      {showNotice && (
        <div className="mobile-site__notice" role="dialog" aria-modal="true">
          <div className="mobile-site__notice-card">
            <h3>Please use desktop</h3>
            <p>Please log in from desktop and register there.</p>
            <button className="mobile-site__notice-btn" onClick={() => setShowNotice(false)}>OK</button>
          </div>
        </div>
      )}
</div>
  );
}
